// Warehouse origin tags shown next to prices so clients see where items ship from.
const WAREHOUSE_TAGS = { us: "US", china: "CN", other: "INT" };
const WAREHOUSE_NAMES = { us: "US warehouse", china: "China warehouse", other: "international warehouse" };

export function warehouseTag(warehouse) {
  const key = (warehouse || "us").toLowerCase();
  return WAREHOUSE_TAGS[key] || key.slice(0, 3).toUpperCase();
}

export function warehouseName(warehouse) {
  const key = (warehouse || "us").toLowerCase();
  return WAREHOUSE_NAMES[key] || `${key} warehouse`;
}
